import {NgModule} from "@angular/core";
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';

const iconsList: string[] = [
  'encircled-arrow',
  'user-profile',
  'support'
];

@NgModule({
  providers: [MatIconRegistry] // Ensure MatIconRegistry is provided globally
})

export class AppIconModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconsList.forEach(icon => {
      iconRegistry.addSvgIcon(
        icon,
        sanitizer.bypassSecurityTrustResourceUrl(`assets/images/${icon}.svg`)
      );
    })
  }
}
